export enum FilterType {
  Open = "open",
  Sentence = "sentence",
  NextDueDate = "nextDueDate",
  Court = "court",
  Close = "close",
  SearchText = "searchText",
  EntityType = "entityType",
  UserOwnedClaims = "userOwnedClaims",
  ActionStatus = "actionStatus",
  Reasons = "selectedReasons",
  CaseHandlers = "selectedCaseHandlers",
}

export enum SavedFiltersTabs {
  ASSIGNED = "ASSIGNED",
  CREATED = "CREATED",
  ALL = "ALL",
}

export enum FilterPermissions {
  MODULE = "admin",
  FEATURE = "ManageEntity",
  OPERATIONS = "Manage Followup",
  SUB_OPERATION_UPDATE = "FollowupService-AddEditFollowupFilter",
  SUB_OPERATION_DELETE = "FollowupService-DeleteFollowUpFilter",
}

export enum PermissionType {
  UPDATE = "update",
  DELETE = "delete",
}
